module.exports = __webpack_public_path__ + "img/TS6102-303.8071202a.jpg";